module.exports = __webpack_public_path__ + "img/stock3.857a03b5.png";